import DescriptionTerm from "./DescriptionTerm";

export default DescriptionTerm